import * as React from 'react';

const KeyboardChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 10h-2V8h2v2zm0 3h-2v-2h2v2zm-3-3h-2V8h2v2zm0 3h-2v-2h2v2zm0 4H8v-2h8v2zm-9-7H5V8h2v2zm0 3H5v-2h2v2zm1-2h2v2H8v-2zm0-3h2v2H8V8zm3 3h2v2h-2v-2zm0-3h2v2h-2V8zM3 5h18v14H3V5z"
        />
    </svg>
);

KeyboardChunkySvg.displayName = 'KeyboardChunkySvg';
export default KeyboardChunkySvg;
